import { Link } from 'react-router-dom'
import { defaultRouteFor, useAuth } from '../auth'

export function ForbiddenPage() {
  const { user } = useAuth()
  return <div className="error-state permission-error"><h1>无权访问</h1><p>当前账号没有该店铺或页面权限。</p>{user ? <Link className="primary-button" to={defaultRouteFor(user)}>返回可用页面</Link> : null}</div>
}
